import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import { GalleryTypeApi } from '../../../../api/gallery-type/gallery-type.api';

const ManageState = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [search, setSearch] = useState<string>("");
    const [id_gallery_type, set_id_gallery_type] = useState<number | null>(null);
    const [status, set_status] = useState<string>("");

    const [showModal, setShowModal] = useState<string>("");

    const [data, setData] = useState<any[]>([]);
    const [date_range, set_date_range] = useState<string[]>([]);

    const [form, set_form] = useState<{ gallery_type_name: string }>({
        gallery_type_name: ""
    })


    const handleCloseModal = () => {
        setShowModal("");
        set_id_gallery_type(null);
        set_form({ gallery_type_name: "" })
    }
    const handleChangeDateRange = (date_range_value: string[]) => {
        set_date_range(date_range_value)
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_complaints_type", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("ชื่อหมวดหมู่ข่าว")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            complaints_type_name,
            create_name,
            created_date,
            modified_date,
            modifier_name,
            status,
            id_gallery_type

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: complaints_type_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modifier_name || create_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => {
                                setShowModal('VIEW');
                            }}
                            onEditClick={() => {
                                setShowModal('EDIT');
                            }}
                            onDeleteClick={() => handleDeleteList(id_gallery_type)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleDeleteList = (id_gallery_type: number) => {
        alertActive(t("ลบหมวดหมู่กิจกรรม"), t("ต้องการลบหมวดหมู่กิจกรรม ? "), undefined, undefined, async () => {
            dispatch(setLoading());
            await GalleryTypeApi.deleteGalleryType(id_gallery_type).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบหมวดหมู่กิจกรรม"), t("ลบหมวดหมู่กิจกรรม เรียบร้อยแล้ว"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบหมวดหมู่กิจกรรม"), t("ลบหมวดหมู่กิจกรรม ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (search) query = { ...query, keyword: search }
        dispatch(setLoading());
        await GalleryTypeApi.getGalleryTypeList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, search])


    // const handleDownloadReport = async () => {
    //     let query: complaintReport = {}
    //     if (search) query = { ...query, keyword: search }
    //     dispatch(setLoading());
    //     await ReportApi.complaintTypeReport(query).then((res) => {
    //         if (res.status < 300) {
    //             const data = res.data;
    //             const blob_file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    //             saveAs(blob_file, t("COMPLAINTS_MANAGE_CATEGORY"))
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //         alertError(t("COMPLAINTS_DOWNLOAD_FILE"), t("COMPLAINTS_DOWNLOAD_FAILED"))
    //     }).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }
    // const handleGetOneDetail = async (id_complaints_type: number, mode: string) => {
    //     setShowModal(mode);
    //     set_id_complaints_type(id_complaints_type)
    //     dispatch(setLoading());
    //     await ComplaintTypeApi.(id_complaints_type).then((res) => {
    //         if (res.status < 300) {
    //             set_complaints_type_form((prev) => ({ ...prev, complaints_type_name: res.data?.data?.complaints_type_name }))
    //         }
    //     }).catch((err) => console.log(err)).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }

    const handleSubmitForm = async () => {
        dispatch(setLoading());
        if (id_gallery_type) {
            await GalleryTypeApi.updateGalleryType(id_gallery_type, { gallery_type_name: form.gallery_type_name }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("แก้ไขหมวดหมู่กิจกรรม"), t('แก้ไขหมวดหมู่กิจกรรม เรียบร้อยแล้ว'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("แก้ไขหมวดหมู่กิจกรรม"), t("แก้ไขหมวดหมู่กิจกรรม ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await GalleryTypeApi.createGalleryType({ gallery_type_name: form.gallery_type_name }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("สร้างหมวดหมู่กิจกรรม"), t("สร้างหมวดหมู่กิจกรรม เรียบร้อยแล้ว"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("สร้างหมวดหมู่กิจกรรม"), t("สร้างหมวดหมู่กิจกรรม ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetData();
    }, [handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setSearch,
        handleChangeDateRange,
        date_range,
        id_gallery_type,
        set_id_gallery_type,
        // handleDownloadReport,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
    }
}

export default ManageState
